export default __webpack_public_path__ + "static/media/IkonFasteIndeks.3cad4b59.svg";